<template>
	<div>
		<div class="public-table-data">
			<div class="item-son" style="margin-bottom: 30px">
				<el-select
					v-model="dictDataSelect"
					placeholder="请选择分类"
					ref="selectReport"
					style="width: 40%"
					clearable
				>
					<el-option
						:value="listParams.categoryId"
						:label="listParams.categoryId"
						style="height: auto"
					>
						<el-tree
							:data="selectData"
							:props="treeProps"
							:render-after-expand="true"
							:expand-on-click-node="false"
							@node-click="handleNodeClick"
						></el-tree>
					</el-option>
				</el-select>
			</div>
			<el-table
				ref="multipleTable"
				size="mini"
				:data="tableData"
				border
				style="width: 100%"
				row-key="menuId"
				v-loading="loading"
				@selection-change="handleSelectionChange"
			>
				>
				<el-table-column type="selection" width="55"> </el-table-column>
				<el-table-column type="index" label="序号" width="80" align="center">
				</el-table-column>
				<el-table-column prop="name" label="名称" width="180" align="center">
				</el-table-column>
				<el-table-column prop="examId" label="标识" width="120" align="center">
				</el-table-column>
				<el-table-column
					prop="categoryName"
					label="分类"
					width="150"
					align="center"
				>
					<template slot-scope="scope">
						<div>
							{{ scope.row.categoryName1 }}-{{ scope.row.categoryName }}
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="categoryName"
					label="题目"
					width="120"
					align="center"
				>
					<template slot-scope="scope">
						<div>维度：{{ scope.row.dimensions }}</div>
						<div>题目：{{ scope.row.questions }}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="categoryName"
					label="数据"
					width="120"
					align="center"
				>
					<template slot-scope="scope">
						<div>参与：{{ scope.row.answers }}</div>
						<div>购买：{{ scope.row.buys }}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="payPrice"
					label="支付价($)"
					width="120"
					align="center"
				>
					<template slot-scope="scope">
						{{
							scope.row.payPrice !== 0
								? `${formatMoney(scope.row.payPrice/100)}`
								: 0
						}}
					</template>
				</el-table-column>
				<el-table-column prop="ctime" label="上架时间" align="center">
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<div class="public-pagination">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="pages.pageNo"
					:page-sizes="[PAGE_SIZE, 50, 100, 200, 400]"
					:page-size="pages.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				>
				</el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
import { PAGE_SIZE, FILE_ROOT, JOB_STATUS } from "@config";
import { formatMoney } from "@utils/filters/filter";
export default {
	data() {
		return {
			total: 0,
			loading: false,
			PAGE_SIZE,
			pages: {
				status: 1,
				pageNo: 1,
				pageSize: PAGE_SIZE,
				appInfoId: "",
				channelAccountId: "",
				categoryId: "",
			},
			tableData: [],
			newdata: [],
			formatMoney,
			dictDataSelect: "",
			selectData: [],
			listParams: {},
			treeProps: {
				//配置选项:此处定义el-tree的label和children为指定属性，  如果不定义取默认，即label和children
				value: "parentId",
				children: "examCategoryVos",
				label: "name",
			},
		};
	},
	created() {
		let appid = localStorage.getItem("appidss");
		let sou = localStorage.getItem("channelAccountIds");
		this.pages.appInfoId = appid;
		this.pages.channelAccountId = sou;
		this.classifyData();
		this.queryTableData();
	},
	methods: {
		handleNodeClick: function (node) {
			this.pages.categoryId = node.categoryId;
			this.dictDataSelect = node.name;
			this.queryTableData();

			this.listParams.categoryId = node.categoryId;
			if (node.parentId == 0) {
				this.listParams.parentId = node.categoryId;
			} else {
				this.listParams.parentId = node.categoryId;
			}
			if (node.id != 0) {
				//this.AccountData.orgId = node.id;
			}
			this.$refs.selectReport.blur();
		},
		// * 获取分类列表
		// */
		async classifyData() {
			this.loading = true;

			const { data: resData } = await this.$get("/exam/category/list", {
				params: {
					status: 1,
					paging: false,
					tree: true,
				},
			});
			this.loading = false;
			if (resData.result != 200) return;
			this.selectData = resData.data.sort(function (a, b) {
				return b.seq - a.seq;
			});
		},
		/**
		 * 获取列表
		 */
		async queryTableData() {
			this.loading = true;

			const { data: resData } = await this.$get("exam/list", {
				params: {
					...this.pages,
				},
			});
			this.loading = false;
			if (resData.result != 200) return;
			this.tableData = resData.data;
			this.total = resData.page.count;
			let arrdata = [];
			this.tableData.forEach((item, index) => {
				if (item.checkboxStatus == 1) {
					arrdata.push(item);
				}
			});
			// this.$emit("childByValue", resData.data);
			this.$nextTick(() => {
				for (let i = 0; i < this.tableData.length; i++) {
					if (this.tableData[i].checkboxStatus == 1) {
						this.$refs.multipleTable.toggleRowSelection(this.tableData[i]);
					}
				}
			});
		},
		handleSelectionChange(val) {
			this.newdata = val;
			this.$emit("childByValue", val);
			//清空选择
			// this.$nextTick(() => {
			//   for (var i = 0; i < this.$refs.multipleTable.length; i++) {
			//     this.$refs.multipleTable[i].clearSelection();
			//   }
			// });
		},
		/**
		 *  分页长度改变
		 */
		handleSizeChange(val) {
			this.pages.pageNo = 1;
			this.pages.pageSize = val;
			this.queryTableData();
		},

		/**
		 *  下一页
		 */
		handleCurrentChange(val) {
			this.pages.pageNo = val;
			this.queryTableData();
		},
	},
};
</script>
